var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9406_3688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.429 0a.571.571 0 0 0-.256.06l-4.33 2.166L5.946.049 5.92.042a.571.571 0 0 0-.136-.035.85.85 0 0 0-.14 0 .594.594 0 0 0-.136.035l-.026.007L.34 2.335A.571.571 0 0 0 0 2.857V15.43a.572.572 0 0 0 .803.522l4.911-2.183 4.911 2.183c.008.003.018 0 .026.005a.504.504 0 0 0 .433-.01c.009-.004.02 0 .028-.006l4.572-2.286a.571.571 0 0 0 .316-.511V.572A.571.571 0 0 0 15.429 0zM5.143 12.771l-4 1.778V3.23l4-1.778v11.32zm5.143 1.778l-4-1.777V1.451l4 1.777v11.32zm4.57-1.76l-3.428 1.715V3.21l3.429-1.714V12.79z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9406_3688"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgMap;